<script setup lang="ts">
// Cadeadinho que fica pendurado no canto do badge de um elo ainda bloqueado.
</script>

<template>
  <span
    class="absolute -bottom-[3px] -right-1 flex h-[17px] w-[17px] items-center justify-center rounded-full bg-[rgba(4,9,22,0.92)] shadow-[inset_0_0_0_1px_rgba(255,255,255,0.16)]"
  >
    <NuxtIcon
      class="text-[9px] text-white/70"
      filled
      name="mini-games/locked"
    />
  </span>
</template>
